export default __webpack_public_path__ + "static/media/dragDots.ea140ce2.svg";